import { FC } from "react";

import ComingSoonPage from "./ComingSoonPage";

const DashboardPage: FC = () => (
  <ComingSoonPage
    title="Dashboard"
    description="Aggregate feedback trends and analytics. Coming soon."
  />
);

export default DashboardPage;
